module.exports = __webpack_public_path__ + "static/media/add-rule.81f4265d.svg";